<template>
  <div>
    <div v-for="item in items" :key="item.id" :id="item.id">
      <Item :item="item" :vat="vat" :soldOut="soldOut" :locations="locations" :categoryChannelIds="categoryChannelIds" @openPanel="(type, params) => $emit('openPanel', type, params)" @refresh="$emit('refresh')"/>
    </div>
  </div>
</template>

<script>
import Item from "@/components/product/Item";

export default {
  components: {Item},
  props: {
    items: Array,
    vat: Object,
    soldOut: { type: Object, default: null }, //SoldOutUtil.index: where each thing is sold out, per location
    locations: { type: Array, default: () => [] },
    categoryChannelIds: { type: Array, default: null }
  },
  emits: ['openPanel', 'refresh'],
  methods: {
  }
}
</script>
